import React from 'react';
import {connect} from "react-redux";
import * as filesActions from "../../../actions/files";

class FileForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value : props.name
        };
    }

    handleChange = (event) => {
        this.setState({value: event.target.value});
    };

    handleSubmit = (e) => {
        this.props.dispatch(filesActions.editFileName(this.props.id, { ...this.props.file, name: this.state.value }, this.props.fogId, this.props.successCallback));
        e.preventDefault();
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.handleSubmit(e);
        }
    };

    render() {
        return (
            <tr className="file-item clickable">
                    <td onClick={this.downloadFile} ><i className={`fa ${this.props.icon}`} aria-hidden="true" /></td>
                    <td onClick={this.downloadFile} ><div className="form-container"><input autoFocus className="input-file-form" onChange={this.handleChange} type="text" placeholder="Document title" value={this.state.value} onKeyDown={this.handleKeyDown} /></div></td>
                    <td><form><button onClick={this.handleSubmit} type="submit" className="btn file-form-btn">submit</button></form></td>
            </tr>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        loading: state.files.loading,
        saving: state.files.saving,
        deleting: state.files.deleting,
        files: state.files.files,
    });
})(FileForm);


// WEBPACK FOOTER //
// ./src/components/fog/FilesUpload/FileForm.js